import { useSelector } from "react-redux"
import { AppState } from "src/state"
import { XFerState } from "src/state/xFer"

export default function useXFerState(): XFerState {
  return useSelector((state: AppState) => state.xFer)
}
